import React, { useCallback, useMemo } from 'react';
import { useFormikContext, useField } from 'formik';
import { tail } from 'ramda';
import PropTypes from 'prop-types';

import TextInput from 'components/TextInputNew';
import Checkbox from 'components/CheckboxNew';
import Select from 'components/SelectNew';
import Radios from 'components/RadiosNew';
import AddressAutocomplete from 'components/AddressAutocomplete';
import { POSITION_TITLES, GENDER_RADIOS } from 'utils/constants';
import {
  TITLE,
  FIRST_NAME,
  LAST_NAME,
  GENDER,
  ADDRESS,
  CANTON,
  COUNTRY,
  ZIP_CODE,
  CITY,
  EMAIL,
  INSTITUTION,
  IS_EMERGENCY,
  CARE_OF,
  AGENT,
  CONTACT_TYPE,
} from 'store/patients';

const ReceiverFrom = ({ type, errors, readMode }) => {
  const { setValues } = useFormikContext();
  const [{ value: emergency }, , { setValue: setEmergency }] = useField(IS_EMERGENCY);
  const [{ value: title }, , { setValue: setTitle }] = useField(TITLE);
  const [firstNameField] = useField(FIRST_NAME);
  const [lastNameField] = useField(LAST_NAME);
  const [{ value: gender }, , { setValue: setGender }] = useField(GENDER);
  const [institutionField] = useField(INSTITUTION);
  const [careOf] = useField(CARE_OF);
  const [{ value: address }] = useField(ADDRESS);
  const [{ value: zipCode }] = useField(ZIP_CODE);
  const [{ value: city }] = useField(CITY);
  const [{ value: canton }] = useField(CANTON);
  const [{ value: country }] = useField(COUNTRY);
  const [emailField] = useField(EMAIL);
  const handleEmergency = useCallback(() => setEmergency(!emergency), [emergency, setEmergency]);
  const options = useMemo(() => (title ? POSITION_TITLES : tail(POSITION_TITLES)), [title]);
  const updateAutocompleteValues = useCallback((data) => setValues(($) => ({ ...$, ...data })), [setValues]);

  return (
    <>
      {(type === AGENT || type === CONTACT_TYPE) && (
        <Checkbox label="Ist Notfallkontakt" selected={emergency} onClick={handleEmergency} readMode={readMode} noLabel />
      )}
      <Select label="Titel" value={title || ''} options={options} onSelect={setTitle} readMode={readMode} />
      <TextInput label="Vorname" {...firstNameField} readMode={readMode} />
      <TextInput label="Nachname" {...lastNameField} readMode={readMode} />
      <Radios value={gender} label="Geschlecht" items={GENDER_RADIOS} setValue={setGender} readMode={readMode} />
      <TextInput label="Institution" {...institutionField} error={errors?.[INSTITUTION]} readMode={readMode} />
      <TextInput label="c/o" {...careOf} readMode={readMode} />
      <AddressAutocomplete
        address={address}
        zipCode={zipCode}
        city={city}
        canton={canton}
        country={country}
        setData={updateAutocompleteValues}
        zipCodeErr={errors?.[ZIP_CODE]}
        readMode={readMode}
      />
      <TextInput label="E-Mail" {...emailField} error={errors?.[EMAIL]} readMode={readMode} />
    </>
  );
};

ReceiverFrom.defaultProps = { errors: null };
ReceiverFrom.propTypes = {
  type: PropTypes.string.isRequired,
  errors: PropTypes.shape({
    [EMAIL]: PropTypes.string,
    [INSTITUTION]: PropTypes.string,
    [ZIP_CODE]: PropTypes.string,
  }),
  readMode: PropTypes.bool.isRequired,
};

export default ReceiverFrom;
